<template>
  <BTable
    :headers="headers"
    :actions="actions"
    :list="list"
    :items-per-page-options="[25, 50, 100, 200]"
    item-key="name"
    hide-default-header
    class="LKReportsRoadmapDirectionEventStatisticsTable"
  >
    <!--  -->

    <template #header>
      <thead>
        <tr>
          <template v-for="header in headers">
            <th
              :key="header.value"
              :width="header.width"
              class="LKReportsRoadmapDirectionEventStatisticsTable__header"
            >
              <div class="LKReportsRoadmapDirectionEventStatisticsTable__vertical-text-container">
                <span
                  class="LKReportsRoadmapDirectionEventStatisticsTable__vertical-text"
                  v-html="header.text"
                />
              </div>
            </th>
          </template>
        </tr>
      </thead>
    </template>

    <template #item="{ item, headers: headersList }">
      <tr
        class="LKReportsRoadmapDirectionEventStatisticsTable__row"
        :class="`is-type--${item.type}`"
      >
        <template v-for="header in headersList">
          <TableCell
            :key="header.value"
            :data="item"
            :header="header"
            :value="item[header.value]"
            :roadmap-id="roadmapId"
          />
        </template>
      </tr>
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import { TABLE_HEADERS } from './table-headers'
import BTable from '@/components/common/BTable.vue'
import TableCell from './LKReportsRoadmapDirectionEventStatisticsTableCell.vue'


export default {
  name: 'LKReportsRoadmapDirectionEventStatisticsTable',
  components: {
    BTable,
    TableCell,
  },
  props: {
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      required: true,
    },
    roadmapId: {
      type: [Number, String],
      required: true,
    },
  },
}
</script>

<style lang="scss">
$border-color: rgba(0, 0, 0, 0.12);

@mixin row-color ($color, $color-hover: $color) {
  background-color: rgba($color, 0.1) !important;

  &:hover {
    background-color: rgba($color-hover, 0.3) !important;
  }
}

.LKReportsRoadmapDirectionEventStatisticsTable {
  th {
    color: $color-black !important;
    text-align: left;
    word-break: break-word;
    border-top: thin solid $border-color;
    border-left: thin solid $border-color;
  }

  tr:last-child td {
    border-bottom: thin solid $border-color;
  }

  // stylelint-disable-next-line no-descending-specificity, selector-list-comma-newline-after
  th, td {
    height: auto !important;
    padding: 8px !important;
    font-size: 12px !important;
    border-left: thin solid $border-color;

    // stylelint-disable-next-line no-descending-specificity
    &:last-child {
      border-right: thin solid $border-color;
    }
  }

  & &__header {
    // width: 60px;
    min-width: 60px;
    // max-width: 140px;
  }

  &__vertical-text {
    $width: 104px;

    word-break: normal;

    @media screen and (max-width: 1300px) {
      position: absolute;
      display: block;
      width: $width;
      padding: 8px 0;
      line-height: 1.2;
      transform: rotate(270deg);

      &-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: $width;
      }
    }
  }

  &__row {
    @include row-color($color-white, $color-white);

    &.is-type {
      &--roadmap_direction {
        @include row-color($webflow-color-grey);
      }

      &--base_event {
        @include row-color($color-white, $webflow-color-grey);
      }
    }
  }
}
</style>
